import React, { useEffect } from 'react';
import { useRecoilState } from 'recoil';
import { useTranslation } from 'react-i18next';

import { TableFiltersWithDate } from 'components';
import { UseTrafficMonitorState } from 'store';
import { CallDirection, FilterOption } from 'types';

type MonitorFiltersProps = {
  direction: CallDirection;
  filters: FilterOption[];
  collapsible?: boolean;
};

export const MonitorFilters: React.FC<MonitorFiltersProps> = ({
  direction,
  filters,
  collapsible = true,
}) => {
  const { filterState, startDateState, endDateState, textSearchState } =
    UseTrafficMonitorState(direction);
  const [monitorFilters, setMonitorFilters] = useRecoilState(filterState);
  const [monitorStartDate, setMonitorStartDate] = useRecoilState(startDateState);
  const [monitorEndDate, setMonitorEndDate] = useRecoilState(endDateState);
  const { t } = useTranslation('monitor');
  useEffect(() => {
    setMonitorFilters(filters);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <TableFiltersWithDate
      filters={monitorFilters}
      onSetSelectedFilters={setMonitorFilters}
      collapsible={collapsible}
      showDateFilter={true}
      initialEndDate={monitorEndDate}
      initialStartDate={monitorStartDate}
      onSetEndDate={setMonitorEndDate}
      onSetStartDate={setMonitorStartDate}
      textSearchState={textSearchState}
      fromDateLabel={t('date_range_from_title', 'Start date')}
      toDateLabel={t('date_range_to_title', 'End date')}
    />
  );
};
